export default {
  //
  TENCENT_CAPTCHA: "2083658304",
}



// WEBPACK FOOTER //
// ./src/assets/js/config.js